import React from 'react';

import { useGridContext } from './context/GridContext';
import { GridFillerProps } from './types';

import cn from './Grid.module.scss';

export const GridFiller = ({ height, depth = 1, theme }: GridFillerProps) => {
  const { filler_width, cumulative_column_widths } = useGridContext();

  if (filler_width > 0) {
    const style: React.CSSProperties = {
      position: 'absolute',
      width: `${filler_width}px`,
      height: `${height * depth}px`,
      right: 'auto',
      left: `${cumulative_column_widths[cumulative_column_widths.length - 1] || 0}px`,
      borderColor: theme.border_color,
      background: theme.background,
    };
    return <div className={cn.boundary} style={style} />;
  }
  return null;
};
